import { render, staticRenderFns } from "./IndexSearch.vue?vue&type=template&id=6c241d90"
import script from "./IndexSearch.vue?vue&type=script&lang=js"
export * from "./IndexSearch.vue?vue&type=script&lang=js"
import style0 from "./IndexSearch.vue?vue&type=style&index=0&id=6c241d90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports